define ['./history.scss'], () ->
  ($state, $scope, $stateParams) ->
    console.log('history loaded')

    $scope.actions = $scope.application.audit_logs
    $scope.grouped = []

    # First group the actions by date
    $scope.actions.map((action) ->
      # Skip application status change logs
      if action.object == 'application' and action.type == 'status_change'
        return
      date = moment(action.timestamp).format('dddd, M/D/YYYY')
      grouped_actions = _.find($scope.grouped, {'date': date })
      action.time = moment(action.timestamp).format('h:mm a')

      if ['user_action', 'mail', 'status_change'].indexOf(action.type) >= 0
        if grouped_actions
            grouped_actions.actions.push(action)
        else
            $scope.grouped.push({
                date: date,
                actions: [ action ]
            })
    )

    # Sort the group and actions
    $scope.grouped = $scope.grouped.map((g) -> 
      g.actions = _.orderBy(g.actions, (a) -> 
        new Date(a.timestamp)
      , 'desc')
      return g
    )

    $scope.grouped = _.orderBy($scope.grouped, (g) -> 
      new Date(g.date)
    , 'desc')




// WEBPACK FOOTER //
// ./components/dashboard/view/history/history.coffee